import { useState } from 'react';
import { ConnectCard } from '@/components/ai-connections/connect-card';
import { ConnectionsTable } from '@/components/ai-connections/connections-table';
import { DashboardLayout } from '@/components/dashboard-layout';
import { PageMeta } from '@/components/page-meta';
import { Container } from '@/components/primitives/container';
import { useAiConnections } from '@/hooks/use-ai-connections';

export function AiConnectionsPage() {
  const [isWaitingForNew, setIsWaitingForNew] = useState(false);
  const { data: connections, isLoading, error } = useAiConnections({ isWaitingForNew });

  return (
    <>
      <PageMeta title="AI connections" />
      <DashboardLayout headerStartItems={<h1 className="text-foreground-950">AI connections</h1>}>
        <Container className="flex w-full max-w-[800px] flex-col gap-6">
          <ConnectCard connections={connections} onWaitingChange={setIsWaitingForNew} />
          <ConnectionsTable connections={connections} isLoading={isLoading} error={error} />
        </Container>
      </DashboardLayout>
    </>
  );
}
